// extracted by mini-css-extract-plugin
export default {"dialog":"CareRecipientSettingDialog_dialog__rWrNx","button":"CareRecipientSettingDialog_button__5g7x+","alertButton":"CareRecipientSettingDialog_alertButton__PMVqd"};